import linkResolver from './linkResolver';
import { Link } from 'react-router-dom';

const CustomLink = ({node, children}) => {
  if (node?.data?.link_type === 'Document') {
    return (
      <Link key={node.data.id} to={linkResolver(node.data)}>
        {children}
      </Link>
    );
  } else {
    return (
      <a key={node?.data?.id} href={node?.data?.url} target={node?.data?.target}>
        {children}
      </a>
    );
  }
};

export default CustomLink;
